import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { createDisableKeepAlivePolicy, pipelineContainsDisableKeepAlivePolicy } from "./policies/disableKeepAlivePolicy.js";
import { redirectPolicyName } from "@azure/core-rest-pipeline";
import { ServiceClient } from "@azure/core-client";
import { toCompatResponse } from "./response.js";
/**
 * Client to provide compatability between core V1 & V2.
 */

export var ExtendedServiceClient = /*#__PURE__*/function (_ServiceClient) {
  _inherits(ExtendedServiceClient, _ServiceClient);

  var _super = _createSuper(ExtendedServiceClient);

  function ExtendedServiceClient(options) {
    var _this;

    _classCallCheck(this, ExtendedServiceClient);

    var _a, _b;

    _this = _super.call(this, options);

    if (((_a = options.keepAliveOptions) === null || _a === void 0 ? void 0 : _a.enable) === false && !pipelineContainsDisableKeepAlivePolicy(_this.pipeline)) {
      _this.pipeline.addPolicy(createDisableKeepAlivePolicy());
    }

    if (((_b = options.redirectOptions) === null || _b === void 0 ? void 0 : _b.handleRedirects) === false) {
      _this.pipeline.removePolicy({
        name: redirectPolicyName
      });
    }

    return _this;
  }
  /**
   * Compatible send operation request function.
   *
   * @param operationArguments - Operation arguments
   * @param operationSpec - Operation Spec
   * @returns
   */


  _createClass(ExtendedServiceClient, [{
    key: "sendOperationRequest",
    value: function () {
      var _sendOperationRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(operationArguments, operationSpec) {
        var _a, userProvidedCallBack, lastResponse, onResponse, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onResponse = function _onResponse(rawResponse, flatResponse, error) {
                  lastResponse = rawResponse;

                  if (userProvidedCallBack) {
                    userProvidedCallBack(rawResponse, flatResponse, error);
                  }
                };

                userProvidedCallBack = (_a = operationArguments === null || operationArguments === void 0 ? void 0 : operationArguments.options) === null || _a === void 0 ? void 0 : _a.onResponse;
                operationArguments.options = Object.assign(Object.assign({}, operationArguments.options), {
                  onResponse: onResponse
                });
                _context.next = 5;
                return _get(_getPrototypeOf(ExtendedServiceClient.prototype), "sendOperationRequest", this).call(this, operationArguments, operationSpec);

              case 5:
                result = _context.sent;

                if (lastResponse) {
                  Object.defineProperty(result, "_response", {
                    value: toCompatResponse(lastResponse)
                  });
                }

                return _context.abrupt("return", result);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendOperationRequest(_x, _x2) {
        return _sendOperationRequest.apply(this, arguments);
      }

      return sendOperationRequest;
    }()
  }]);

  return ExtendedServiceClient;
}(ServiceClient);